import { render, staticRenderFns } from "./JoinGroupWithInviteCode.vue?vue&type=template&id=0fc72fce&scoped=true&"
import script from "./JoinGroupWithInviteCode.vue?vue&type=script&lang=js&"
export * from "./JoinGroupWithInviteCode.vue?vue&type=script&lang=js&"
import style0 from "./JoinGroupWithInviteCode.vue?vue&type=style&index=0&id=0fc72fce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc72fce",
  null
  
)

component.options.__file = "JoinGroupWithInviteCode.vue"
export default component.exports